import { GESTION_OPERATIVA_CLOSE_COMMENT_DRAWER } from './constants'

export const closeCommentDrawer = () => {
  return dispatch => {
    dispatch({
      type: GESTION_OPERATIVA_CLOSE_COMMENT_DRAWER
    })
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_CLOSE_COMMENT_DRAWER) {
      return {
        ...state,
        commentDrawerOpen: false,
      }
  }
  else{
    return state
  }
}